import type {CSSProperties} from 'react';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeBriefSheetLook = 'brief-sheet-edit';

const BRIEF_SHEET_LOOKS = new Set<string>(['brief-sheet-edit']);
export const isWedgeBriefSheetLook = (look: string | undefined): look is WedgeBriefSheetLook => look !== undefined && BRIEF_SHEET_LOOKS.has(look);

/* Released Tuned by you sheet action (Edit in Settings, Industry). A full width button 44px tall with a 12px radius, a 6px top
   margin, the label fill, the surface ink, no border, and 14px semibold type in the Wedge font. It keeps the declaration order of
   the source and reads the exact legacy roles. It declares no display, as the source does. It draws no transparent target and no
   anchor (wedgeSettingsDrawsHit): its own 44px height already meets the target size and it spans the sheet. */
export function wedgeBriefSheetStyle(look: WedgeBriefSheetLook): CSSProperties {
  const r = wedgeExactRole;
  switch (look) {
    case 'brief-sheet-edit': return {
      width: '100%', height: 44, borderRadius: 12,
      background: r('label'), color: r('bg'), border: 0,
      cursor: 'pointer', fontSize: 14, fontWeight: 600, fontFamily: r('font'),
      marginTop: 6,
    };
  }
}
